// Module
var code = `<div class="info info--deposit">
  <div class="info-detail">
    <span class="key">Product name:</span>
    <span class="value">
      {{\$ctrl.accountDetails.productName}}
    </span>
  </div>
  <div class="info-detail">
    <span class="key">Available balance:</span>
    <span class="value"
          ng-class="{'currency--positive': \$ctrl.accountDetails.balance > 0, 'currency--negative': \$ctrl.accountDetails.balance < 0}">
      {{\$ctrl.accountDetails.balance | nxCurrency}}
    </span>
  </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/deposit-product-information/deposit-product-information.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;